import { render, staticRenderFns } from "./BatchageDetail.vue?vue&type=template&id=2c13638b"
import script from "./BatchageDetail.vue?vue&type=script&lang=js"
export * from "./BatchageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports